export const InformationRowSizeThemes = {
    sm: {
        label: 'body3',
        value: 'overline',
        icon: 12,
        gapVertical: 'xs',
        gapHorizontal: 'xs',
    },
    md: {
        label: 'body3',
        value: 'body2',
        icon: 16,
        gapVertical: 'sm',
        gapHorizontal: 'xs',
    },
    lg: {
        label: 'body2',
        value: 'body1',
        icon: 20,
        gapVertical: 'sm',
        gapHorizontal: 'sm',
    },
};
